import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-general-configuration',
  templateUrl: './general-configuration.component.html'
})
export class GeneralConfigurationComponent {
  isThisSectionVisible = true;

  toggleVisibility() {
    console.log(this.isThisSectionVisible);
    this.isThisSectionVisible = !this.isThisSectionVisible;
  }

  @Input()
  parentForm!: FormGroup;

  @Output()
  openHelpModal: EventEmitter<any> = new EventEmitter();

  constructor() {}
}
